import { BiChevronDown, BiChevronRight, BiPencil, BiPlus } from "react-icons/bi";
import { RowMenu } from "../rowMenu";
import { SidebarArticleRow } from "./articleSideBar";
import { BsLayers, BsTrash2 } from "react-icons/bs";
import { ICONS } from "../../../utils/Utils";

export const SidebarSubcategoryRow = ({
  subcategory,
  articles,
  isSelected,
  selectedArticleId,
  expanded,
  onToggle,
  onSelect,
  onSelectArticle,
  onEdit,
  onDelete,
  onAddArticle,
  onEditArticle,
  onDeleteArticle,
}) => {
  return (
    <div>
      <div
        onClick={() => {
          onToggle();
          onSelect();
        }}
        className={`group flex cursor-pointer items-center justify-between gap-2 rounded-md px-2 py-1.5 pl-6 text-sm transition-colors ${isSelected ? "bg-slate-100 font-medium text-slate-900" : "text-slate-600 hover:bg-slate-100"
          }`}
      >
        <div className="flex min-w-0 items-center gap-1.5">
          {expanded ? <BiChevronDown size={13} className="shrink-0 text-slate-400" /> : <BiChevronRight size={13} className="shrink-0 text-slate-400" />}
          {ICONS[subcategory?.icon]}
          <span className="truncate">{subcategory.name}</span>
          <span className="shrink-0 text-xs text-slate-400">{articles.length}</span>
        </div>
        <div className="flex shrink-0 items-center opacity-0 group-hover:opacity-100">

          <button
            aria-label="Add article"
            title="Add article"
            type="button"
            className="inline-flex items-center justify-center rounded-md p-1.5 text-slate-500 hover:bg-slate-200/70 hover:text-slate-900 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-600"
            onClick={(e) => {
              e.stopPropagation();
              onAddArticle();
            }}
          >
            <BiPlus size={14} />
          </button>
          <RowMenu
            items={[
              { label: "Edit subcategory", icon: <BiPencil size={13} />, onClick: onEdit },
              { label: "Delete subcategory", icon: <BsTrash2 size={13} />, onClick: onDelete, danger: true },
            ]}
          />
        </div>
      </div>
      {expanded && (
        <div className="mt-0.5 space-y-0.5">
          {articles.length === 0 && <p className="pl-9 py-1 text-xs text-slate-400">No articles yet</p>}
          {articles.map((a) => (
            <SidebarArticleRow
              key={a.id}
              article={a}
              isSelected={selectedArticleId === a.id}
              onSelect={() => onSelectArticle(a)}
              onEdit={() => onEditArticle(a)}
              onDelete={() => onDeleteArticle(a)}
            />
          ))}
        </div>
      )}
    </div>
  );
}